// extracted by mini-css-extract-plugin
export default {"loanRequest":"LoanRequest_loanRequest__jz1IN","loanRequest__text":"LoanRequest_loanRequest__text__cJ7Sp","loanRequest__total":"LoanRequest_loanRequest__total__NFseV"};